import React from 'react';
import {useIntl} from 'react-intl';
import {getGradients} from '../../util/ChartsUtil';
import {Chart} from '@/web-components';
import {BUDGET_TYPE} from '../../../../../../constants';
import {remapAndFormatFinancialMessage} from '../../../../../../forecast-app/shared/util/FinancialInternationalisationUtil';
import {chartTokens} from '@forecast-it/design-system';

const CostChart = ({project, data, hasBaseline, eyeOptionMap, modifyChartOptions, isUsingNewFixedPriceCalculation}) => {
	const intl = useIntl();
	const {formatMessage} = intl;
	const isFixedPriceProject = [BUDGET_TYPE.FIXED_PRICE, BUDGET_TYPE.FIXED_PRICE_V2].includes(project.budgetType);
	const {plannedCostChartData, totalCostAtCompletionChartData, baselineCostChartData, fixedPriceChartData} = data;
	const {gradientFill, gradientStrokeFixedPrice} = getGradients();
	const dataSets = [];

	const chartColors = chartTokens.chart.color;

	if (isFixedPriceProject && !isUsingNewFixedPriceCalculation && fixedPriceChartData.length > 0) {
		dataSets.unshift({
			name: formatMessage({id: 'common.fixed_price'}),
			color: gradientStrokeFixedPrice,
			backgroundColor: isUsingNewFixedPriceCalculation ? 'transparent' : '#fff',
			data: fixedPriceChartData,
		});
	}

	if (hasBaseline && eyeOptionMap.baseline) {
		dataSets.unshift({
			name: formatMessage({id: 'project_budget.baseline_cost'}),
			color: chartColors['4'],
			backgroundColor: 'transparent',
			data: baselineCostChartData,
			borderWidth: 1,
		});
	}

	if (eyeOptionMap.plan) {
		dataSets.unshift({
			name: remapAndFormatFinancialMessage({id: 'project_budget.planned_cost'}),
			color: chartColors['7'],
			backgroundColor: isUsingNewFixedPriceCalculation ? 'transparent' : gradientFill,
			data: plannedCostChartData,
			borderWidth: 3,
		});
	}

	if (totalCostAtCompletionChartData.length && eyeOptionMap.forecast) {
		dataSets.unshift({
			name: remapAndFormatFinancialMessage({id: 'project_budget.forecast_cost'}),
			color: chartColors['2'],
			backgroundColor: 'transparent',
			data: totalCostAtCompletionChartData,
			borderWidth: 2,
		});
	}

	return <Chart dataSets={dataSets} modifyOptions={modifyChartOptions} usePointStyle />;
};

export default CostChart;
